// extracted by mini-css-extract-plugin
export default {"head":"styles_head__Cx2QY","title":"styles_title__9L3Gi","topText":"styles_topText__JMcJa","subtitle":"styles_subtitle__LBOoX","titleText":"styles_titleText__N3+Yq"};